import { en } from './en.ts';
import { nl } from './nl.ts';
import { fr, type Catalogue, type MessageKey } from './fr.ts';

export type Locale = 'fr' | 'en' | 'nl';
export type { MessageKey };

export const LOCALES: Record<Locale, { label: string; messages: Catalogue }> = {
  fr: { label: 'Français', messages: fr },
  en: { label: 'English', messages: en },
  nl: { label: 'Nederlands', messages: nl },
};

export type Translate = (key: MessageKey, params?: Record<string, string | number>) => string;

export function translator(locale: Locale): Translate {
  const messages = LOCALES[locale].messages;
  return (key, params) => {
    let s: string = messages[key] ?? fr[key] ?? key;
    if (params) for (const [k, v] of Object.entries(params)) s = s.replaceAll(`{${k}}`, String(v));
    return s;
  };
}

/** Pick the best supported locale from the browser/OS preferences. French by default. */
export function detectLocale(preferred: readonly string[] = []): Locale {
  for (const tag of preferred) {
    const base = tag.toLowerCase().split('-')[0];
    if (base === 'fr' || base === 'en' || base === 'nl') return base;
  }
  return 'fr';
}

/** BCP 47 tag for dates and numbers (Belgian French and Dutch, British English). */
export const localeTag = (l: Locale) => (l === 'fr' ? 'fr-BE' : l === 'nl' ? 'nl-BE' : 'en-GB');
